module.exports = __webpack_public_path__ + "img/folder-line.3c74707e.svg";